import { EntityState, EntityStore, getEntityType } from "@datorama/akita";
import { DocumentReference } from "@angular/fire/firestore";

export class FirebaseStore<S extends EntityState = EntityState, EntityType = getEntityType<S>> extends EntityStore<S> {
  akitaPreAddEntity(entity: Partial<EntityType>): getEntityType<S> {
    FirebaseStore.removeUndefined(entity);
    return entity as getEntityType<S>;
  }

  akitaPreUpdateEntity(_: Readonly<EntityType>, nextEntity: Partial<EntityType>): getEntityType<S> {
    FirebaseStore.removeUndefined(nextEntity);
    return nextEntity as getEntityType<S>;
  }

  toId(obj: string | DocumentReference): string {
    if (!obj) return null;
    return typeof obj === "string" ? obj : obj.id;
  }

  static removeUndefined<T>(obj: T): T {
    if (Array.isArray(obj)) {
      obj.forEach(o => this.removeUndefined(o));
    } else {
      Object.keys(obj).forEach(key => obj[key] === undefined && delete obj[key]);
    }

    return obj;
  }
}
